import { render, staticRenderFns } from "./VendorListApp.vue?vue&type=template&id=24c5de40&scoped=true"
import script from "./VendorListApp.vue?vue&type=script&lang=js"
export * from "./VendorListApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5de40",
  null
  
)

export default component.exports